import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomOutlet } from '@/components/functional/Link/CustomOutlet';
import { PrevPathContextProvider } from '@/context/PrevPathContext';
import { HotlineClientCreateFormContextProvider } from '@/feature/hotline/client/create/context/HotlineClientCreateFormContext';
/**
 * 匿名ホットライン投稿 共通レイアウト
 */
export const HotlineClientCreateLayout = () => (_jsx(PrevPathContextProvider, { children: _jsx(HotlineClientCreateFormContextProvider, { children: _jsx(CustomOutlet, {}) }) }));
